import { render } from "./Modal.vue?vue&type=template&id=2dc9e6b3"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=2dc9e6b3&lang=scss"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge.PrimeraEntrevista\\PircaSolutions.Forge.PrimeraEntrevista.UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__